module.exports = __webpack_public_path__ + "img/img20.4cd09648.svg";